import { useState } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { useLang } from "@/i18n";
import { EmployeesTab } from "@/components/EmployeesTab";
import { PayslipsTab } from "@/components/PayslipsTab";
import { AbsencesTab } from "@/components/AbsencesTab";

export default function Payroll() {
  const { t } = useLang();
  const [tab, setTab] = useState("payslips");
  return (
    <div className="space-y-5 page-enter" data-testid="payroll-page">
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="bg-slate-100 dark:bg-slate-800">
          <TabsTrigger value="payslips" data-testid="payroll-tab-payslips">{t("payslips")}</TabsTrigger>
          <TabsTrigger value="employees" data-testid="payroll-tab-employees">{t("employees")}</TabsTrigger>
          <TabsTrigger value="absences" data-testid="payroll-tab-absences">{t("absences")}</TabsTrigger>
        </TabsList>
        <TabsContent value="payslips" className="mt-5"><PayslipsTab /></TabsContent>
        <TabsContent value="employees" className="mt-5"><EmployeesTab /></TabsContent>
        <TabsContent value="absences" className="mt-5"><AbsencesTab /></TabsContent>
      </Tabs>
    </div>
  );
}
